import React from 'react';
import './sectionTitle.css';

const SectionTitle = ({ text = '', align = null }) => {
  if (!text) {
    return null;
  }
  const className = `sectionTitle ${align || ''}`;
  return <h3 className={className}>{text}</h3>;
};

export default SectionTitle;
